// الترجمات — الدارجة المغربية
export default {
  'common.save': 'حفظ',
  'common.cancel': 'بطل',
  'common.delete': 'حيّد',
  'common.edit': 'عدّل',
  'common.confirm': 'أكد',
  'common.close': 'سد',
  'common.search': 'قلّب',
  'common.loading': 'كيتحمّل...',
  'common.error': 'غلطة',
  'common.retry': 'عاود',
  'common.add': 'زيد',
  'common.back': 'رجع',
  'common.next': 'التالي',
  'common.all': 'الكل',
  'common.yes': 'واه',
  'common.no': 'لا',

  'home.nav_features': 'الخدمات',
  'home.nav_how': 'كيفاش كيخدم',
  'home.nav_pricing': 'الثمن',
  'home.nav_faq': 'أسئلة',
  'home.create_site': 'دير السيت ديالي',
  'home.my_space': 'الفضاء ديالي',
  'home.logout': 'خرج',

  'auth.login': 'دخول',
  'auth.register': 'تسجيل',
  'auth.client_space': 'فضاء الكليان',
  'auth.client_space_desc': 'الشريات والملفات ديالي',
  'auth.pro_space': 'فضاء المهني',
  'auth.pro_space_desc': 'سيّر الحانوت ديالي',

  'dash.dashboard': 'لوحة التحكم',
  'dash.products': 'السلع',
  'dash.caisse': 'الكاسة',
  'dash.services': 'الخدمات',
  'dash.orders': 'الطلبات',
  'dash.customers': 'الكليان',
  'dash.credit': 'الدين',
  'dash.payments': 'الأداء',
  'dash.wallet': 'البورتفاي',
  'dash.store': 'الحانوت',
  'dash.my_website': 'Mit website',
  'dash.site_content': 'محتوى السيت',
  'dash.media': 'الميديا',
  'dash.documents': 'الوثائق',
  'dash.storage': 'التخزين',
  'dash.analytics': 'الإحصائيات',
  'dash.appstore': 'متجر التطبيقات',
  'dash.apps': 'التطبيقات ديالي',
  'dash.themestore': 'متجر القوالب',
  'dash.settings': 'الإعدادات',
  'dash.account': 'الحساب ديالي',
  'dash.profile': 'البروفيل',
  'dash.install_app': 'ثبّت التطبيق',
  'dash.my_qr': 'الـ QR ديالي',
  'dash.logout': 'خرج',
  'dash.notifications': 'الإشعارات',
  'dash.preview_site': 'شوف قبل',
  'dash.view_site': 'شوف السيت',

  'sa.dashboard': 'لوحة التحكم',
  'sa.users': 'المستعملين',
  'sa.core': 'Zifek Core',
  'sa.themes': 'بانّي القوالب',
  'sa.apps': 'بانّي التطبيقات',
  'sa.homepage': 'الصفحة الرئيسية',
  'sa.translations': 'اللغات والترجمات',
  'sa.support': 'دعم الكليان',
  'sa.logs': 'السجلات',
  'sa.accountTypes': 'Kontotyper',
  'sa.database': 'Database og API',
  'sa.storage': 'التخزين',
  'sa.settings': 'إعدادات الذكاء',

  'support.title': 'خدمة الكليان والدعم',
  'support.new_ticket': 'تيكي جديد',
  'support.subject': 'الموضوع',
  'support.message': 'الرسالة',
  'support.send': 'صيفط',
  'support.reply': 'رد',
  'support.status': 'الحالة',
  'support.open': 'مفتوح',
  'support.in_progress': 'كيتعالج',
  'support.resolved': 'تحل',
  'support.closed': 'مسدود',
  'support.zifek_team': 'فريق زيفيك',
  'support.contact_team': 'تواصل مع فريق زيفيك',
  'support.my_requests': 'الطلبات ديالي',

  'credit.title': 'دفتر الدين',
  'credit.carnet': 'الدفتر',
  'credit.clients': 'الكليان',
  'credit.reports': 'التقارير',
  'credit.settings': 'الإعدادات',
  'credit.add_credit': 'زيد دين',
  'credit.record_payment': 'سجّل تسديد',
  'credit.balance': 'الرصيد',
  'credit.new_customer': 'كليان',
  'credit.import_photo': 'صورة الديون',
  'credit.scan': 'سكان',

  'lang.change': 'بدّل اللغة',

  'credit.subtitle': 'الدفتر الرقمي ديال الدين',
  'credit.tab.carnet': 'الدفتر',
  'credit.tab.clients': 'الكليان',
  'credit.tab.rapports': 'التقارير',
  'credit.tab.reglages': 'الإعدادات',
  'credit.photo_debts': 'صورة الديون',
  'credit.add_credit_btn': 'زيد دين',
  'credit.search_client': 'قلّب على كليان...',
  'cr.qa_payment': 'سجّل تسديد',
  'cr.qa_add_client': 'زيد كليان',
  'cr.qa_import_photo': 'دخّل من صورة',
  'cr.qa_invite': 'عيّط كليان',
  'cr.qa_statement': 'دير كشف الحساب',
  'cr.qa_carnet': 'الدفتر كامل',

  'caisse.title': 'الكاسة ديالي',
  'caisse.subtitle': 'ماكينة الكاسة',
  'caisse.search': 'قلّب على سلعة...',
  'caisse.cart': 'الپانية',
  'caisse.empty': 'الپانية خاوية',
  'caisse.checkout': 'خود الفلوس',
  'caisse.new_sale': 'بيع جديد',
  'caisse.subtotal': 'المجموع الجزئي',
  'caisse.tax': 'الضريبة',
  'caisse.total': 'المجموع',
  'caisse.cash': 'كاش',
  'caisse.card': 'كارط',
  'caisse.paid': 'تخلّص',

  'products.title': 'السلع',
  'products.subtitle': 'سيّر الكاطالوغ ديال السلع',
  'products.new': 'سلعة جديدة',
  'products.categories': 'الفئات',
  'products.catalog': 'الكاطالوغ',
  'products.stock_mgmt': 'تدبير المخزون',
  'products.search': 'قلّب على سلعة...',
  'reports.title': 'التقارير',

  'currency.change': 'بدّل العملة',
  'currency.equiv': 'كيسوى',
  'credit.enable_reminders': 'فعّل التذكير بالدين',

  'orders.title': 'الطلبات',
  'orders.subtitle': 'تبّع وسيّر گاع الطلبات',
  'orders.filter_all': 'الكل',
  'orders.filter_pending': 'كيتسنى',
  'orders.filter_paid': 'مخلّصة',
  'orders.filter_processing': 'كيتعالج',
  'orders.filter_shipped': 'تصيفطت',
  'orders.filter_delivered': 'توصلت',
  'orders.empty': 'مكاينش طلبات',
  'orders.empty_hint': 'الطلبات غادي تبان هنا منين تجيك',
  'orders.items': 'السلع',
  'orders.subtotal': 'المجموع الجزئي',
  'orders.shipping': 'التوصيل',
  'orders.tax': 'الضرائب',
  'orders.discount': 'التخفيض',
  'orders.total': 'المجموع',
  'orders.status': 'الحالة',
  'orders.payment': 'الأداء',
  'orders.email': 'الإيميل',
  'orders.phone': 'التيليفون',

  'payments.title': 'الأداء',
  'payments.subtitle': 'تاريخ المعاملات والمداخيل',
  'payments.received': 'توصلت',
  'payments.sent': 'صيفطت',
  'payments.balance': 'الرصيد الحالي',
  'payments.filter_all': 'الكل',
  'payments.filter_received': 'متوصلين',
  'payments.filter_sent': 'مصيفطين',
  'payments.empty': 'مكاينش معاملات',
  'payments.empty_hint': 'المعاملات غادي تبان هنا',
  'payments.col_type': 'النوع',
  'payments.col_amount': 'المبلغ',
  'payments.col_details': 'التفاصيل',
  'payments.col_origin': 'المصدر',
  'payments.col_date': 'التاريخ',
  'payments.in': 'توصلت',
  'payments.out': 'صيفطت',

  'wallet.title': 'البورتفاي',
  'wallet.subtitle': 'الرصيد، التعمير وتاريخ العمليات.',
  'wallet.available': 'الرصيد المتوفر',
  'wallet.recharge': 'عمّر البورتفاي',
  'wallet.via_paypal': 'عمّر عبر PayPal',
  'wallet.via_stripe': 'عمّر عبر Stripe',
  'wallet.history': 'تاريخ العمليات',
  'wallet.empty': 'مكاينش عمليات دابا.',
  'wallet.col_type': 'النوع',
  'wallet.col_amount': 'المبلغ',
  'wallet.col_method': 'الطريقة',
  'wallet.col_details': 'التفاصيل',
  'wallet.col_date': 'التاريخ',
  'wallet.type_recharge': 'تعمير',
  'wallet.type_refund': 'إرجاع',
  'wallet.type_debit': 'خصم',
  'wallet.method_wallet': 'البورتفاي',
  'wallet.method_admin': 'المسؤول',

  'settings.title': 'الإعدادات',
  'settings.subtitle': 'سيّر الحساب والتفضيلات ديالك',
  'settings.tab_profile': 'البروفيل',
  'settings.tab_password': 'كلمة السر',
  'settings.tab_domain': 'الدومين',
  'settings.tab_appearance': 'المظهر',
  'settings.tab_danger': 'منطقة الخطر',

  'crf.tx_add_credit': 'زيد دين',
  'crf.tx_record_payment': 'سجّل خلاص',
  'crf.tx_adjustment': 'تعديل',
  'crf.tx_hint_credit': 'المبلغ اللي باقي عليك الكليان فوق',
  'crf.tx_hint_payment': 'المبلغ اللي كيردّ ليك الكليان',
  'crf.tx_hint_adjustment': 'تصحيح (مبلغ سالب باش تنقّص الدين)',
  'crf.current_balance': 'الرصيد دابا',
  'crf.amount': 'المبلغ',
  'crf.description': 'الوصف',
  'crf.description_credit_ph': 'مثلا: كيس الروز، الزيت…',
  'crf.description_payment_ph': 'مثلا: خلاص جزئي',
  'crf.payment_method': 'طريقة الخلاص',
  'crf.new_balance': 'الرصيد الجديد',
  'crf.confirm': 'أكد',
  'crf.saving': 'كيتسجل...',
  'crf.invalid_amount': 'دخل مبلغ صحيح.',
  'crf.save_error': 'غلطة فالتسجيل',
  'crf.edit_customer': 'عدّل الكليان',
  'crf.new_customer': 'كليان جديد',
  'crf.customer_name': 'سمية الكليان',
  'crf.customer_name_ph': 'مثلا: محمد العلمي',
  'crf.customer_hint': 'ماكاين حتى حساب زيفيك مطلوب. الكليان يقدر يتعيّط من بعد باش يتبع الرصيد ديالو.',
  'crf.phone_optional': 'التيليفون (اختياري)',
  'crf.credit_limit_optional': 'سقف الدين (اختياري)',
  'crf.usual_payment_date': 'تاريخ الخلاص المعتاد',
  'crf.not_defined': 'ماشي محدد',
  'crf.day_of_month': 'نهار {day} من الشهر',
  'crf.notes_optional': 'ملاحظات (اختياري)',
  'crf.notes_ph': 'مثلا: جار، كيخلّص آخر الشهر…',
  'crf.name_required': 'سمية الكليان ضرورية.',
  'crf.create_customer': 'دير الكليان',
  'crf.client_access': 'دخول الكليان',
  'crf.client_access_desc': 'هاهي معطيات الدخول ديال الكليان. شاركها معاه باش يدخل للفضاء ديالو ويتبع الرصيد والسجل.',
  'crf.username': 'المعرّف',
  'crf.default_password': 'كلمة السر الافتراضية',
  'crf.client_space': 'فضاء الكليان',
  'crf.share': 'شارك',
  'crf.regen_password': 'جدّد كلمة السر',
  'crf.creds_hint': 'الكليان يقدر حتى يبدّل كلمة السر من الفضاء ديالو.',
  'crf.import_title': 'دخّل الديون من صورة',
  'crf.import_sub_upload': 'صوّر صفحة الدفتر',
  'crf.import_sub_confirm': 'التأكيد مطلوب',
  'crf.import_sub_review': 'راجع من بعد أكّد',
  'crf.import_desc': 'دير صورة ولا كثر لصفحة الدفتر (الأسماء + المبالغ). من بعد الذكاء الاصطناعي يقرا الديون ويعرضهم ليك للتأكيد. حتى شي حاجة ما كتتسجل قبل ما تأكد.',
  'crf.take_photos': 'صوّر / ختار صور',
  'crf.photos_hint': 'حتى 8 صور · JPG، PNG',
  'crf.import_history': 'سجل الاستيراد',
  'crf.import_cancelled': 'ملغى',
  'crf.cancel_btn': 'بطل',
  'crf.revert_hint': 'إلغاء الاستيراد كيحيّد الديون اللي تدارو (و الكليان اللي تدارو بهاد الاستيراد).',
  'crf.add_line': 'زيد سطر',
  'crf.detected_total': '{count} دين مكتشف · المجموع {total}',
  'crf.debt_detail_ph': 'التفصيل (مثلا: جوج كيسان دقيق، الخبز…)',
  'crf.existing_customer_tag': 'كليان كاين — الدين غادي يتزاد للحساب ديالو',
  'crf.no_debt': 'مكاين دين. زيد سطر بيدك.',
  'crf.ai_read_none': 'الذكاء الاصطناعي ما قرا حتى دين فهاد الصور. جرب صورة واضحة ومزيانة الإضاءة.',
  'crf.ai_failed': 'فشل تحليل الذكاء الاصطناعي',
  'crf.add_at_least_one': 'زيد على الأقل دين واحد بسمية ومبلغ.',
  'crf.confirm_existing_title': 'كليان/كليانة كاينين',
  'crf.confirm_existing_desc': 'هاد الأسماء كاينين فالدفتر ديالك. واش كتأكد إضافة هاد الديون للحسابات اللي عندهم؟',
  'crf.new_clients_count': 'غادي يتدارو حتى {count} كليان جداد.',
  'crf.creating_progress': 'كيتدارو الكليان والديون... {done}/{total}',
  'crf.analyse_ai': 'حلّل بالذكاء الاصطناعي',
  'crf.reading_ai': 'كيتقرا...',
  'crf.back': 'رجع',
  'crf.validate_create': 'أكد ودير',
  'crf.confirm_add_existing': 'أكد وزيد للحسابات اللي كاينين',
  'crf.import_failed': 'فشل الاستيراد',
  'crf.revert_failed': 'فشل الإلغاء',
  'crf.revert_question': 'تلغي هاد الاستيراد؟',
  'crf.revert_desc': 'تحيّد {count} دين.',
  'crf.currency': 'العملة',
  'crf.currency_desc': 'كتستعمل فكل دفتر الدين.',
  'crf.default_due_day': 'نهار الاستحقاق الافتراضي',
  'crf.no_due_day': 'ماشي محدد',
  'crf.reminders': 'التذكيرات',
  'crf.reminders_desc': 'التذكيرات كيتصيفطو للكليان عبر التطبيق ديال زيفيك (PWA) إلا كان مثبّت. إلا ما ثبّتوش، ما كيتصيفط حتى تذكير أوتوماتيكي.',
  'crf.reminder_new_credit': 'دين جديد',
  'crf.reminder_payment': 'تأكيد الخلاص',
  'crf.reminder_balance': 'الرصيد دابا',
  'crf.reminder_due_date': 'استحقاق قريب',
  'crf.reminder_monthly': 'كشف شهري',
  'crf.default_channel': 'القناة الافتراضية',
  'crf.channel_inapp': 'تطبيق الكليان (PWA)',
  'crf.merchant_qr': 'رمز دعوة التاجر',
  'crf.merchant_qr_desc': 'بيّن هاد الرمز فالكاسة. الكليانة ديالك المتصلين بزيفيك كيسكانّيوه باش يربطو الحساب بالدفتر ديالك.',
  'crf.show_qr': 'بيّن الرمز',
  'crf.last_reminders': 'آخر التذكيرات',
  'crf.save_settings': 'سجّل الإعدادات',
  'crf.saved': 'تسجل!',
  'crf.qr_client': 'رمز الكليان',
  'crf.merchant_invite': 'دعوة التاجر',
  'crf.link_customer': 'رابط ربط الكليان',
  'crf.to_pay': 'للخلاص',
  'crf.up_to_date': 'مزيان',
  'crf.limit_badge': 'السقف',
  'crf.no_phone': 'بلا تيليفون',
  'crf.ledger_empty_title': 'الدفتر ديالك خاوي',
  'crf.ledger_empty_desc': 'زيد كليان من بعد سجّل دين فثواني — بحال دفتر ورقي ولكن بلا ورق.',
  'crf.add_customer': 'زيد كليان',
  'crf.no_client_found': 'ملقيناش كليان',
  'crf.export_csv': 'صدّر CSV',
  'crf.no_customer': 'ماكاينش كليانة',
  'crf.col_client': 'الكليان',
  'crf.col_balance': 'الرصيد',
  'crf.col_limit': 'السقف / المتوفر',
  'crf.col_due': 'الاستحقاق',
  'crf.col_actions': 'الإجراءات',
  'crf.no_limit': 'بلا سقف',
  'crf.available_short': 'متوفر',
  'crf.linked_account': 'حساب مربوط',
  'crf.last_activity': 'آخر',
  'crf.tooltip_add_credit': 'زيد دين',
  'crf.tooltip_payment': 'خلاص',
  'crf.tooltip_invite': 'عيّط لزيفيك',
  'crf.tooltip_credentials': 'شوف معطيات الدخول',
  'crf.tooltip_edit': 'عدّل',
  'crf.tooltip_delete': 'حيّد',
  'crf.stat_outstanding': 'مجموع الدين الجاري',
  'crf.stat_with_credit': 'كليانة عندهم دين',
  'crf.stat_credits_month': 'ديون هاد الشهر',
  'crf.stat_payments_month': 'مدفوعات توصلو هاد الشهر',
  'crf.stat_attention': 'كليانة للمتابعة',
  'crf.rep_export_balances': 'الأرصدة CSV',
  'crf.rep_export_history': 'السجل CSV',
  'crf.rep_from': 'من',
  'crf.rep_to': 'ألى',
  'crf.rep_reset': 'صفر',
  'crf.rep_credits_period': 'الديون (الفترة)',
  'crf.rep_payments_period': 'المدفوعات (الفترة)',
  'crf.rep_adjust_period': 'التعديلات (الفترة)',
  'crf.rep_credits_vs_payments': 'الديون مقابل المدفوعات',
  'crf.rep_last_6': 'آخر 6 شهور',
  'crf.rep_credits': 'الديون',
  'crf.rep_payments': 'المدفوعات',
  'crf.rep_client_balances': 'أرصدة الكليانة',
  'crf.rep_no_balance': 'ماكاين رصيد جاري',
  'crf.rep_payment_history': 'سجل المدفوعات',
  'crf.rep_no_payment': 'ماكاينش خلاص فالفترة',
  'crf.rep_deleted_client': 'كليان محيّد',
  'crf.rep_type_credit': 'دين',
  'crf.rep_type_payment': 'خلاص',
  'crf.rep_type_adjust': 'تعديل',

  'csf.all_categories': 'الكل',
  'csf.no_result': 'ماكاينش نتيجة',
  'csf.no_active_product': 'ماكاينش سلعة نشيطة',
  'csf.try_other': 'جرب كلمة أخرى',
  'csf.add_active_hint': 'زيد سلع بحالة "نشيطة"',
  'csf.out_of_stock': 'خلص المخزون',
  'csf.remaining': 'باقي',
  'csf.promo': 'تخفيض',
  'csf.clear': 'فرّغ',
  'csf.click_to_add': 'كليكي على سلعة باش تزيدها للپانية',
  'csf.cash_payment': 'خلاص كاش',
  'csf.card_payment': 'خلاص بالكارط',
  'csf.amount_to_pay': 'المبلغ للخلاص',
  'csf.amount_received': 'المبلغ اللي توصل',
  'csf.change_to_give': 'الصرف',
  'csf.insert_card': 'دخّل ولا مرّر الكارط',
  'csf.terminal_hint': 'جهاز مربوط · الخلاص بلا لمس مقبول',
  'csf.insufficient': 'المبلغ اللي توصل ما كافيش.',
  'csf.processing': 'كيتخلّص...',
  'csf.validate_payment': 'أكد الخلاص',
  'csf.back': 'رجع',
  'csf.payment_accepted': 'تخلّص',
  'csf.order': 'طلب',
  'csf.articles': 'السلع',
  'csf.payment_method': 'طريقة الخلاص',
  'csf.cash_label': 'كاش',
  'csf.card_label': 'كارط بنكية',
  'csf.change_label': 'الصرف',
  'csf.new_sale': 'بيع جديد',
  'csf.check_access': 'كتّحقق من الدخول...',
  'csf.load_error': 'غلطة فتحميل السلع',
  'csf.sale_offline_error': 'ماقدرناش نسجلو البيع بلا شبكة',
  'csf.sale_error': 'غلطة فالخلاص',

  'prf.new_title': 'سلعة جديدة',
  'prf.new_subtitle': 'زيد سلعة للكاطالوغ ديالك',
  'prf.edit_title': 'عدّل السلعة',
  'prf.created': 'تدارت السلعة بنجاح!',
  'prf.updated': 'تحدّثت السلعة بنجاح!',
  'prf.uploading_media': 'كيتحمّلو الميديا...',
  'prf.general_info': 'معلومات عامة',
  'prf.product_name': 'سمية السلعة',
  'prf.product_name_ph': 'مثلا: تيشيرت پريميوم',
  'prf.description': 'الوصف',
  'prf.description_ph': 'وصف السلعة ديالك...',
  'prf.category': 'الفئة',
  'prf.no_category': 'بلا فئة',
  'prf.status': 'الحالة',
  'prf.status_draft': 'مسودة',
  'prf.status_active': 'نشيطة',
  'prf.status_inactive': 'ماشي نشيطة',
  'prf.price': 'الثمن',
  'prf.stock': 'المخزون',
  'prf.enable_promo': 'فعّل التخفيض',
  'prf.promo_price': 'ثمن التخفيض',
  'prf.media': 'الميديا',
  'prf.cover_image': 'صورة الغلاف',
  'prf.click_drag_image': 'كليكي ولا سحب صورة',
  'prf.click_drag_video': 'كليكي ولا سحب فيديو',
  'prf.additional_images': 'صور زايدة',
  'prf.add': 'زيد',
  'prf.short_video': 'فيديو قصير',
  'prf.variants': 'المتغيرات',
  'prf.has_variants': 'هاد السلعة عندها متغيرات (مقاسات، ألوان...)',
  'prf.variant_type_ph': 'النوع (مثلا: المقاس)',
  'prf.variant_options_ph': 'الخيارات (مثلا: S، M، L)',
  'prf.add_variant_type': 'زيد نوع متغير',
  'prf.pricing': 'التسعير:',
  'prf.single_price': 'ثمن وحد',
  'prf.per_variant': 'ثمن لكل متغير',
  'prf.combination': 'التركيبة',
  'prf.generated_combos': 'التركيبات اللي تدارو',
  'prf.create_product': 'دير السلعة',
  'prf.save': 'سجّل',
  'prf.saving': 'كيتسجل...',
  'prf.creating': 'كيتدار...',
  'prf.cancel': 'بطل',
  'prf.name_required': 'السمية ضرورية',
  'prf.invalid_price': 'ثمن ماشي صحيح',
  'prf.invalid_stock': 'مخزون ماشي صحيح',
  'prf.invalid_promo': 'ثمن تخفيض ماشي صحيح',
  'prf.image_url': 'صورة (URL)',
  'prf.view_details': 'شوف التفاصيل',
  'prf.edit_btn': 'عدّل',
  'prf.uploading': 'كيتحمّل...',
} as Record<string, string>;